import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCalendarSelectDayComponent } from "./med-icon-calendar-select-day.component";

@NgModule({
  declarations: [
    MedIconCalendarSelectDayComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCalendarSelectDayComponent,
  ],
})
export class MedIconCalendarSelectDayModule { }
